import { Timestamp } from "firebase/firestore";
import { useEffect } from "react";
import {
  fetchAndSetData,
  fetchArtistList,
  fetchPartialData,
  fetchShortList,
  fetchSongList,
  fetchUpdateList,
} from "../api/fetch.api";
import { compareUpdates } from "../tools/cache.util";
import {
  getLocalStorageItem,
  setLocalStorageItem,
  timestampToDate,
} from "../tools/tools";
import { Collections, Song, Update } from "../types/type";
import { useRecoilState, useSetRecoilState } from "recoil";
import { artistListState, shortListState, songListState } from "../atom/atom";

const LOCAL_STORAGE_UPDATE_KEY = "Update";
type FetchAndSetDataDictionary = {
  [key: string]: [() => Promise<any>, any];
};

type UpdateItem = {
  id: string;
  allUpdateDate: Timestamp;
  updateDocumentId: string;
  updateDate: Timestamp;
};

export const useCache = () => {
  const [totalSongList, setTotalSongList] = useRecoilState(songListState);
  const [totalShortList, setTotalShortList] = useRecoilState(shortListState);
  const [totalArtistList, setTotalArtistList] = useRecoilState(artistListState);

  useEffect(() => {
    const fetch = async () => {
      // update 컬렉션 fetch
      const fetchedUpdateList = await fetchUpdateList();
      console.log("fetchedUpdateList : ", fetchedUpdateList);

      const songUpdate = fetchedUpdateList[2];
      const shortUpdate = fetchedUpdateList[1];
      const artistUpdate = fetchedUpdateList[0];

      // 로컬 updateList 불러오기
      const localUpdateList: Update[] | null = getLocalStorageItem(
        LOCAL_STORAGE_UPDATE_KEY
      );
      if (!localUpdateList || localUpdateList.length < 3) {
        console.log("localUpdateList 업데이트 필요 !!!");
        console.log("fetchedUpdateList :", fetchedUpdateList);
        const [totalSongList, totalShortList, totalArtistList] =
          await Promise.all([
            fetchSongList(),
            fetchShortList(),
            fetchArtistList(),
          ]);
        setLocalStorageItem(totalSongList, Collections.SONG);
        setLocalStorageItem(totalShortList, Collections.SHORT);
        setLocalStorageItem(totalArtistList, Collections.ARTIST);
        setLocalStorageItem(fetchedUpdateList, LOCAL_STORAGE_UPDATE_KEY);
        setTotalSongList(totalSongList);
        setTotalShortList(totalShortList);
        setTotalArtistList(totalArtistList);
      } else {
        const handleUpdate = async (
          update: Update,
          localUpdate: Update,
          collectionName: string,
          fetchList: () => Promise<any[]>,
          setList: React.Dispatch<React.SetStateAction<any[]>>,
          itemIdField: string
        ) => {
          if (
            timestampToDate(localUpdate.allUpdateDate).getTime() !==
            timestampToDate(update.allUpdateDate).getTime()
          ) {
            console.log(`${collectionName} allUpdateDate 다름 !!!`);
            const totalList = await fetchList();
            setLocalStorageItem(totalList, collectionName);
            setLocalStorageItem(fetchedUpdateList, LOCAL_STORAGE_UPDATE_KEY);
            setList(totalList);
          } else if (
            timestampToDate(localUpdate.updateDate).getTime() !==
            timestampToDate(update.updateDate).getTime()
          ) {
            console.log(`${collectionName} updateDate 다름 !!!`);
            const localTotalList = getLocalStorageItem(collectionName);

            const localLastItem = localTotalList.slice(-1)[0];
            const lastItemId = localLastItem[itemIdField];
            const fetchedList = await fetchPartialData(
              collectionName,
              lastItemId,
              itemIdField
            );
            const totalList = [...localTotalList, ...fetchedList];

            setLocalStorageItem(totalList, collectionName);
            setLocalStorageItem(fetchedUpdateList, LOCAL_STORAGE_UPDATE_KEY);
            setList(totalList);
          } else {
            console.log(`${collectionName} 업데이트 안해도 됨 !!`);
            const localTotalList = getLocalStorageItem(collectionName);
            setList(localTotalList);
          }
        };

        await Promise.all([
          handleUpdate(
            songUpdate,
            localUpdateList[2],
            Collections.SONG,
            fetchSongList,
            setTotalSongList,
            "songId"
          ),
          handleUpdate(
            shortUpdate,
            localUpdateList[1],
            Collections.SHORT,
            fetchShortList,
            setTotalShortList,
            "shortId"
          ),
          handleUpdate(
            artistUpdate,
            localUpdateList[0],
            Collections.ARTIST,
            fetchArtistList,
            setTotalArtistList,
            "artistId"
          ),
        ]);
      }
    };

    fetch();
  }, []);

  // useEffect(() => {
  //   console.log("totalSongList : ", totalSongList);
  //   console.log("totalArtistList : ", totalArtistList);
  //   console.log("totalShortList : ", totalShortList);
  // }, [totalSongList.length]);
};
